<div
  class="contents"
  kPullToRefresh>
  <k-cookies-consent ngSkipHydration></k-cookies-consent>
  <router-outlet></router-outlet>
  <k-lightbox></k-lightbox>
  @if (routeLazyLoadingSig() && !initialLoaderActiveSig()) {
    <div
      class="fixed inset-0 z-[11000] flex items-center justify-center bg-black/70 pointer-events-auto touch-none backdrop-blur-sm">
      <k-loading
        type="spinner"
        size="large"></k-loading>
    </div>
  }
</div>
